import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.SoldOutModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.SoldOutModal = (function (parent) {
    __extends(SoldOutModal, parent);

    var scope = this;

    function SoldOutModal() {
        /** new HSN.SoldOutModal() **/
        var modal = SoldOutModal.__super__.constructor.call(this);

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeSoldOutModal(modal);
        });
        $(modal.Content).on('click', '#confirm', function() {
            closeSoldOutModal(modal);
            return false;
        });
    }

    function closeSoldOutModal(modal) {
        modal.Hide();
        $('html,body').animate({
            scrollTop: $('.soldout-items-container').offset().top
        }, 500);
    }

    /**
    * HSN.SoldOutModal#Show() -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    SoldOutModal.prototype._show = function () {
        var scope = this;
        var soldOutMessage = '<div class="sold-out-modal">';
        soldOutMessage += '<div class="module">';
        soldOutMessage += '<div class="title">you have great taste!</div>';
        soldOutMessage += '<div class="message">An item in your bag has just sold out! Save it for later to receive an alert when the item comes back.</div>';
        soldOutMessage += '<div class="message">If you continue through checkout, the sold out item will be removed from your bag.</div>';
        soldOutMessage += '<div id="confirm" class="submit-button main-button blue">OK</div>';
        soldOutMessage += '</div>';
        soldOutMessage += '</div>';
        scope.Root.removeClass('loading');
        scope.Content.showHtml(
            soldOutMessage,
            0,
            function () {
                scope.Center();
                scope.Content.animate({ opacity: 1 });
            },
            function () {
            }
        );
    };
    return SoldOutModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/Checkout/SoldOutModal.js